import { ManuteRequestConfig } from '@/api/types';
import { GoalRequest, GoalQueryParams } from '@/api/requests/evaluator/types';
import { MediaRequest } from '@/api/requests/types';

/**
 * Request to find all goals.
 * @param params
 */
export const ALL = (params?: GoalQueryParams): ManuteRequestConfig => ({
    method: 'GET',
    url: '/goals',
    params: {
        page_size: 50,
        ...params,
    },
});

/**
 * Request to save a new goal.
 * @param data
 */
export const STORE = (data: GoalRequest): ManuteRequestConfig => ({
    method: 'POST',
    url: '/goals',
    data,
});

/**
 * Request to find a goal by id.
 * @param goalId
 */
export const FIND = (goalId: number): ManuteRequestConfig => ({
    method: 'GET',
    url: `/goals/${goalId}`,
});

/**
 * Request to update an existing goal.
 * @param goalId
 * @param data
 */
export const UPDATE = (goalId: number, data: GoalRequest): ManuteRequestConfig => ({
    method: 'PUT',
    url: `/goals/${goalId}`,
    data,
});

/**
 * Request to delete a goal by id.
 * @param goalId
 */
export const DELETE = (goalId: number): ManuteRequestConfig => ({
    method: 'DELETE',
    url: `/goals/${goalId}`,
});

/**
 * Request to add a media to an existing work.
 *
 * @param workId
 * @param data
 * @param onUploadProgress
 */
export const ADD_MEDIA = (
    goalId: number,
    data: FormData,
    onUploadProgress: (progressEvent: ProgressEvent) => void = (progressEvent) => { return; },
): ManuteRequestConfig => ({
    method: 'POST',
    url: `/goals/${goalId}/media`,
    headers: { 'Content-Type': 'multipart/form-data' },
    data,
    onUploadProgress,
});

/**
 * Request to update a media of an existing work.
 *
 * @param workId
 * @param mediaId
 * @param data
 * @constructor
 */
export const UPDATE_MEDIA = (goalId: number, mediaId: number, data: MediaRequest): ManuteRequestConfig => ({
    method: 'PUT',
    url: `/goals/${goalId}/media/${mediaId}`,
    data,
});

/**
 * Request to remove an existing media from a work.
 * @param workId
 * @param mediaId
 */
export const REMOVE_MEDIA = (goalId: number, mediaId: number): ManuteRequestConfig => ({
    method: 'DELETE',
    url: `/goals/${goalId}/media/${mediaId}`,
});

/**
 * Request to download a existing media of a work.
 * @param workId
 * @param mediaId
 */
export const DOWNLOAD_MEDIA = (goalId: number, mediaId: number): ManuteRequestConfig => ({
    method: 'GET',
    url: `/goals/${goalId}/media/${mediaId}/download`,
    responseType: 'blob',
});


